import React from "react";
import GalleryComponent from "./gallery.component";
import { useSelector } from "react-redux";

export default function GalleryContainer({ id, currentLanguage, previewMode, isTemplateEditor, getTranslation }) {
  const {
    isVisible,
    content: { images, order }
  } = useSelector(state => isTemplateEditor
    ? state.products.template.workspaceSetting.setting.components[id]
    : state.productPage.components[id]);
  const lang = useSelector(state => state.constant.languages);
  const isEnableFullscreenBtn = useSelector(state => isTemplateEditor
    ? state.products.template.workspaceSetting.setting.components[id].content.isEnableFullscreenBtn ?? false
    : state.productPage.components[id].content.isEnableFullscreenBtn ?? false);

  const activeOrder = Array.isArray(order) && order.length > 0 && order[0].value
    ? (previewMode && (
      order.find(e => e.lang === currentLanguage)?.value === undefined ||
      (typeof order.find(e => e.lang === currentLanguage)?.value === "object" &&
      Object.keys(order.find(e => e.lang === currentLanguage)?.value).length === 0)
    ))
      ? order.find(e => e.lang === "EN")?.value || []  // Fallback to "EN"
      : order.find(e => e.lang === currentLanguage)?.value || []
    : order;

  const activeImages = Array.isArray(images) && images.length > 0
  ? (previewMode && (
      images.find(e => e.lang === currentLanguage)?.value !== undefined &&  // Ensure lang exists
      typeof images.find(e => e.lang === currentLanguage)?.value === "object" &&
      Object.keys(images.find(e => e.lang === currentLanguage)?.value).length === 0
    ))
      ? images.find(e => e.lang === "EN")?.value || {}  // Use "EN" if the value is an empty object
      : images.find(e => e.lang === currentLanguage)?.value || images.find(e => e.lang === "EN")?.value || {}
  : images;

  return (
    isVisible && <GalleryComponent
      order={order}
      images={images}
      activeOrder={activeOrder}
      activeImages={activeImages}
      lang={lang}
      isEnableFullscreenBtn={isEnableFullscreenBtn}
      getTranslation={getTranslation}
    />
  );
}
